<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('historicoVentasPorCliente')}}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("companya")}}</label>

                                <el-select class="select-default"
                                            size="large"
                                            v-model="idCompany"
                                            filterable
                                            @change="getBusiness()"
                                            :placeholder="$t('seleccionaCompania')">
                                    <el-option v-for="c in listCompany"
                                            class="select-primary"
                                            :value="c.id"
                                            :label="c.name"
                                            :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                            size="large"
                                            v-model="idBusiness"
                                            filterable
                                            :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses"
                                            class="select-primary"
                                            :value="business.id"
                                            :label="business.establishmentName"
                                            :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label for="clientes">Clientes</label>
                                <el-select class="select-default"
                                            size="large"
                                            v-model="idCliente"
                                            data-is-search="true"
                                            filterable
                                            remote
                                            @change="getSalesClient()"
                                            :placeholder="$t('buscarPorNombreDelCliente')"
                                            :remote-method="searchCliente">
                                    <el-option v-for="c in listClientes"
                                            class="select-primary"
                                            :value="c.id"
                                            :label="c.name  +' '+ c.surName"
                                            :key="c.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="form-group mb-3 mb-md-0" style="white-space: nowrap; overflow: visible;">
                                <label style="display: flex; align-items: center; cursor: pointer; font-weight: normal; margin-bottom: 0;">
                                    <input type="checkbox" v-model="mostrarClientesBaja" style="margin-right: 6px;">
                                    {{ $t('mostrarClientesBaja') }}
                                </label>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <button class="btn btn-primary" @click="getSalesClient()" style="width: 100%" :disabled="loading">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12 row justify-content-right ml-0 mb-2" v-else-if="respuesta">
                <el-dropdown>
                <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme")
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong>
                    </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcelProductAgrupado">
                    <el-dropdown-item class="text-success">
                        <strong><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }} Productos agrupados por Clientes</strong>
                    </el-dropdown-item>
                    </a>
                </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div class="col-md-12" v-if="respuesta && permiso">
                <template v-if="list && list.length > 0">

                    <div class="row justify-content-between div-export" v-if="!vistaTicket">


                    </div>

                    <template v-if="!vistaTicket">

                        <div class="table-responsive" style="overflow-x: auto;">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                <tr>

                                    <th>Tipo</th>
                                    <th>{{$t('fecha')}}</th>
                                    <th v-if="ordenarCliente===0" @click="sortedArrayNameASC('name')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("cliente")}}
                                    </th>
                                    <th v-else @click="sortedArrayNameDESC('name')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("cliente")}}
                                    </th>
                                    <th>
                                        <!--<i style="color: white" class="fa fa-angle-down"></i>--> {{$t("cifnif")}}
                                    </th>
                                    <th>
                                        <!--<i style="color: white" class="fa fa-angle-down"></i>--> {{$t("barcode")}}
                                    </th>
                                    <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('amount')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("importe")}}
                                    </th>
                                    <th v-else @click="sortedArrayImporteDESC('amount')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("importe")}}
                                    </th>
                                    <th>{{$t('pagosaldo')}}</th>

                                    <th>{{$t('saldoAnterior')}}</th>
                                    <th>{{$t('saldoActual')}}</th> 

                                    <th v-if="ordenarImporte===0" @click="sortedArrayImporteASC('amount')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("imp")}} {{$t('sinIVA')}}
                                    </th>
                                    <th v-else @click="sortedArrayImporteDESC('amount')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("imp")}} {{$t('sinIVA')}}
                                    </th>
                                    <th v-if="ordenarImporteDto===0" @click="sortedArrayImporteDtoASC('amount')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t('imp')}} {{$t('sinDto')}}
                                    </th>
                                    <th v-else @click="sortedArrayImporteDtoDESC('amount')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t('imp')}} {{$t('sinDto')}}
                                    </th>
                                    <th v-if="ordenarImporteDto===0" @click="sortedArrayImporteDtoASC('amount')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t('imp')}} {{$t('sinDto')}} {{$t('sinIVA')}}
                                    </th>
                                    <th v-else @click="sortedArrayImporteDtoDESC('amount')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t('imp')}} {{$t('sinDto')}} {{$t('sinIVA')}}
                                    </th>
                                    <th v-if="ordenarConsumiciones===0" @click="sortedArrayConsumicionesASC('units')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t('nTickets')}}
                                    </th>
                                    <th v-else @click="sortedArrayConsumicionesDESC('units')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t('nTickets')}}
                                    </th>
                                    <th v-if="ordenarInvitations===0" @click="sortedArrayInvitationsASC('invitations')">
                                        <i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("invitaciones")}}
                                    </th>
                                    <th v-else @click="sortedArrayInvitationsDESC('invitations')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("invitaciones")}}
                                    </th>
                                    <th v-if="ordenarComensales===0" @click="sortedArrayComensalesASC('comensales')">
                                        <i
                                                style="color: white" class="fa fa-angle-up"></i> {{$t("comensales")}}
                                    </th>
                                    <th v-else @click="sortedArrayComensalesDESC('comensales')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("comensales")}}
                                    </th>
                                    <th v-if="ordenarMedio===0" @click="sortedArrayMedioASC('amount/units')"><i
                                            style="color: white" class="fa fa-angle-up"></i> {{$t("media")}}
                                    </th>
                                    <th v-else @click="sortedArrayMedioDESC('amount/units')"><i
                                            style="color: white" class="fa fa-angle-down"></i> {{$t("media")}}
                                    </th>
                                    <th>Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(obj, index) in list" :key="generateUniqueKey(obj, index)">

                                    <td class="text-center">
                                        <!-- <el-tooltip class="item" effect="dark" :content="obj.saldo.actionType ? 'Recarga' : 'Consumo'" placement="top">
                                            <span :class="obj.saldo.actionType ? 'badge badge-success' : 'badge badge-primary'">&nbsp;</span>
                                        </el-tooltip> -->
                                        <el-tooltip class="item" effect="dark" :content="obj.saldo && obj.saldo.actionType ? 'Recarga' : 'Consumo'" placement="top">
                                            <span :class="obj.saldo && obj.saldo.actionType ? 'badge badge-success' : 'badge badge-primary'">&nbsp;</span>
                                        </el-tooltip>
                                    </td>
                                    <td>{{obj.date | parseDate}}</td>
                                    <td>
                                        {{ obj.name }} {{ obj.surName || '' }}
                                        <span style="color: red" v-if="obj.clientActive == 0">[{{ $t('BAJA') }}]</span>
                                    </td>
                                    <td>{{obj.cifNif}}</td>
                                    <td>{{obj.barCode}}</td>
                                    <td align="right">{{ obj.amount | formatCurrency }}</td>
                                    <td align="right">{{ obj.amountPagoSaldo | formatCurrency }}</td>
                                    <td align="right">{{ obj.saldo.saldoAnterior | formatCurrency }}</td>
                                    <td align="right">{{ obj.saldo.saldoActual | formatCurrency }}</td>
                                    <!-- <td align="right">
                                        <el-tooltip v-if="obj.saldo.saldoActual !== '-'" class="item" effect="dark" :content="obj.saldo.saldoDescription" placement="top">
                                            <span>{{ obj.saldo.saldoActual | formatCurrency }}</span>
                                        </el-tooltip>
                                        <span v-else>-</span>
                                    </td> -->
                                    <td align="right">{{obj.amountSinIVA | formatCurrency}}</td>
                                    <td align="right">{{obj.totalAmountSinDto | formatCurrency}}</td>
                                    <td align="right">{{obj.totalAmountSinDtoSinIVA | formatCurrency}}</td>
                                    <td align="right">{{obj.units}}</td>
                                    <td align="right">{{obj.invitations}}</td>
                                    <td align="right">{{obj.numComensales}}</td>
                                    <td align="right">{{obj.amount / obj.units | formatCurrency}}</td>
                                    <td>
                                        <div class="acciones-icons text-center">
                                            <span class="btn-link btn">
                                                <i
                                                    @click="getTicketsClient(obj.days)"
                                                    class="fas fa-arrow-circle-right"
                                                    style="cursor: pointer"
                                                    v-tooltip.top-center="$i18n.t('verTicketsDeEsasInvitaciones')"
                                                ></i>
                                            </span>
                                            <el-tooltip 
                                                class="item" 
                                                effect="dark" 
                                                :content="obj.saldo.saldoDescription 
                                                    ? (obj.saldo.actionType 
                                                        ? `Ajuste de saldo realizado: ${obj.saldo.saldoDescription}` 
                                                        : `Consumo registrado: ${obj.saldo.saldoDescription}`) 
                                                    : (obj.saldo.actionType 
                                                        ? 'Ajuste de saldo realizado' 
                                                        : 'Consumo registrado')"
                                                placement="top">
                                                <span class="btn-link btn">
                                                    <i
                                                        class="fas fa-info-circle"
                                                        style="cursor: pointer"
                                                    ></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr class="table-success">
                                    <td><strong>{{$t("total")}}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><strong>{{getTotalPrecio | currency}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPagoSaldo | currency}}</strong></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><strong>{{getTotalPrecioSinIVA | currency}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPrecioDto | currency}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPrecioDtoSinIVA | currency}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalConsumiciones}}</strong></td>
                                    <td class="text-right"><strong>{{getTotalComensales }}</strong></td>
                                    <td class="text-right"><strong>{{getTotalInvitacion }}</strong></td>
                                    <td class="text-right"><strong>{{getTotalPrecio /getTotalConsumiciones | currency}}</strong></td>
                                    <td></td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>

                    </template>

                    <template v-else>
                        <div class="card">
                            <div class="col-md-3">
                                <button @click="vistaTicket=false" class="btn btn-primary"><i
                                        class="fas fa-arrow-circle-left"></i>
                                    {{$t("volverALaLista")}}
                                </button>
                            </div>
                            <div class="col-md-12">
                                <template v-for="ticket in listTickets">
                                    <ticket :ticket="ticket"></ticket>
                                </template>
                            </div>
                        </div>


                    </template>


                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHay")}} <strong>{{$t("ventasPorClientes")}}</strong> {{$t("rangoDeFechas")}}
                    </div>
                </template>

            </div>

        </div>
    </div>
</template>

<script>

    import Datepicker from 'vuejs-datepicker';
    import Chart from 'chart.js';
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'
    import Ticket from '../../../Widgets/Ticket.vue'
    import { mapState } from 'vuex'
    import { Tooltip } from 'element-ui';

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Histórico de ventas por clientes");
            this.getCompanies();

            if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
                this.datefrom = this.$store.getters.dateFrom;
                this.dateto = this.$store.getters.dateTo;
            }

        },
        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            'ticket': Ticket,
            ElTooltip: Tooltip
        },
        data() {
            return {
                loading: false,
                datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
                dateto: new Date().toISOString(),
                value4: [new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()],
                listBusinesses: [],
                idBusiness: 0,
                list: [],
                mode: 0,
                contador: 0,
                chartIn: 0,
                listCompany: [],
                idCompany: 0,

                //Tickets
                vistaTicket: false,
                tickets: [],

                idCliente: '',
                listClientes: [],
                mostrarClientesBaja: false,

                ordenarInvitations: 0,
                ordenarComensales: 0,
                ordenarConsumiciones: 0,
                ordenarImporte: 0,
                ordenarImporteDto: 0,
                ordenarCliente: 0,
                ordenarMedio: 0,

                respuesta: true,
            }
        },
        computed: {
            ...mapState(["permiso"]),
            urlExportExcel() {
            
                return this.$store.getters.apiUrl+"/clients/exportSalesByClient/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&idCliente=" + this.idCliente + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            urlExportExcelProductAgrupado() {
            
                return this.$store.getters.apiUrl+"/clients/exportSalesByClient/Excel?idBusiness=" + this.idBusiness + "&idCompany=" + this.idCompany + "&idCliente=" + this.idCliente + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
            },
            // listWithType() {
            //     return this.list.map(item => ({
            //         ...item,
            //         tipo: (Array.isArray(item.saldo) && item.saldo.length === 0) || (typeof item.saldo === 'object' && Object.keys(item.saldo).length === 0) ? 0 : 1
            //     }));
            // },

            getTotalPrecioDto() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmountSinDto;
                });
                return total;
            },
            getTotalPrecioDtoSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.totalAmountSinDtoSinIVA;
                });
                return total;
            },

            getTotalPrecio() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount;
                });
                return total;
            },
            getTotalPagoSaldo(){
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amountPagoSaldo;
                });
                return total;
            },
            getTotalPrecioSinIVA() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amountSinIVA;
                });
                return total;
            },
            getTotalConsumiciones() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.units;
                });
                return total;
            },
            getTotalComensales() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.numComensales;
                });
                return total;
            },
            getTotalInvitacion() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.invitations;
                });
                return total;
            },
            getTotalMedia() {
                let total = 0;
                this.list.forEach(function (d) {

                    total += d.amount / d.units;
                });
                return total;
            }
        },
        watch: {
            mostrarClientesBaja() {
                this.idCliente = '';
                this.listClientes = [];
                if (this.list.length > 0) {
                    this.list = [];
                    this.respuesta = true;
                }
            }
        },
        methods: {
            generateUniqueKey(obj, index) {
                return `${obj.id}-${obj.idDay || 'admin'}-${obj.date}-${index}`;
            },
            sortedArrayNameASC: function () {
                this.ordenarCliente = 1;

                function compare(a, b) {
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayNameDESC: function () {
                this.ordenarCliente = 0;

                function compare(a, b) {

                    if (a.name.toUpperCase() > b.name.toUpperCase())
                        return -1;
                    if (a.name.toUpperCase() < b.name.toUpperCase())
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteASC: function () {
                this.ordenarImporte = 1;

                function compare(a, b) {
                    if (a.amount < b.amount)
                        return -1;
                    if (a.amount > b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDESC: function () {
                this.ordenarImporte = 0;

                function compare(a, b) {

                    if (a.amount > b.amount)
                        return -1;
                    if (a.amount < b.amount)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDtoASC: function () {
                this.ordenarImporteDto = 1;

                function compare(a, b) {
                    if (a.totalAmountSinDto < b.totalAmountSinDto)
                        return -1;
                    if (a.totalAmountSinDto > b.totalAmountSinDto)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayImporteDtoDESC: function () {
                this.ordenarImporteDto = 0;

                function compare(a, b) {

                    if (a.totalAmountSinDto > b.totalAmountSinDto)
                        return -1;
                    if (a.totalAmountSinDto < b.totalAmountSinDto)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayConsumicionesASC: function () {
                this.ordenarConsumiciones = 1;

                function compare(a, b) {
                    if (a.units < b.units)
                        return -1;
                    if (a.units > b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayConsumicionesDESC: function () {
                this.ordenarConsumiciones = 0;

                function compare(a, b) {

                    if (a.units > b.units)
                        return -1;
                    if (a.units < b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayInvitationsASC: function () {
                this.ordenarInvitations = 1;

                function compare(a, b) {
                    if (a.invitations < b.invitations)
                        return -1;
                    if (a.invitations > b.invitations)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayInvitationsDESC: function () {
                this.ordenarInvitations = 0;

                function compare(a, b) {
                    if (a.invitations > b.invitations)
                        return -1;
                    if (a.invitations < b.invitations)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayComensalesASC: function () {
                this.ordenarComensales = 1;

                function compare(a, b) {
                    if (a.numComensales < b.numComensales)
                        return -1;
                    if (a.numComensales > b.numComensales)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayComensalesDESC: function () {
                this.ordenarComensales = 0;

                function compare(a, b) {

                    if (a.numComensales > b.numComensales)
                        return -1;
                    if (a.numComensales < b.numComensales)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayMedioASC: function () {
                this.ordenarMedio = 1;

                function compare(a, b) {
                    if (a.amount / a.units < b.amount / b.units)
                        return -1;
                    if (a.amount / a.units > b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            sortedArrayMedioDESC: function () {
                this.ordenarMedio = 0;

                function compare(a, b) {

                    if (a.amount / a.units > b.amount / b.units)
                        return -1;
                    if (a.amount / a.units < b.amount / b.units)
                        return 1;
                    return 0;
                }

                return this.list.sort(compare);
            },
            getCompanies() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getCompaniesByUser", config)
                    .then(function (response) {

                        if (!vm.idCompany) {
                            vm.idCompany = response.data.result[0].id;
                        }
                        vm.listCompany = response.data.result;

                        vm.getBusiness()

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getBusiness() {
                var config = {
                    params: {
                        idCompany: this.idCompany,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByCompany", config)
                    .then(function (response) {
                        vm.listClientes = [];
                        vm.idCliente = '';
                        vm.listBusinesses = [];


                        if (response.data.result.length > 0) {


                            let xDate = {

                                checked: false,
                                establishmentName: vm.$t('todos'),
                                id: 0
                            };
                            vm.listBusinesses.push(xDate);
                        }


                        for (let i = 0; i < response.data.result.length; i++) {

                            let xDate = {

                                checked: response.data.result[i].checked,
                                establishmentName: response.data.result[i].establishmentName,
                                id: response.data.result[i].id
                            };

                            vm.listBusinesses.push(xDate);
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSalesClient() {

                if (this.datefrom === null || this.dateto === null) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
                else if (this.idCliente === '') {

                    swal({
                        title: this.$t('ups'),
                        text: this.$t('seleccioneUnClienteValido'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }

                else {

                    let secondsDesde = moment(this.datefrom).unix();
                    let secondsHasta = moment(this.dateto).unix();

                    if (secondsHasta < secondsDesde) {
                        swal({
                            title: this.$t('ups'),
                            text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    } else {
                        this.loading = true;

                        this.$store.dispatch("setDateTo", this.dateto);
                        this.$store.dispatch("setDateFrom", this.datefrom);

                        var config = {
                            params: {
                                idBusiness: this.idBusiness,
                                idCompany: this.idCompany,
                                datefrom: moment(this.datefrom).startOf("day").unix(),
                                dateto: moment(this.dateto).endOf("day").unix(),
                                idCliente: this.idCliente,
                                jwt: this.$store.getters.jwt
                            },
                            headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                        };

                        let vm = this;
                        this.axios.get(this.$store.getters.apiUrl + "clients/getVentasByClient", config)
                            .then(function (response) {
                                if (response.data.response) {
                                    vm.list = response.data.result;
                                    vm.respuesta = true;
                                }else if (response.data.response == false && response.data.rangoMayor == true) {
                                    swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                    });
                                    vm.respuesta = false;
                                }
                                else {
                                    swal({
                                        title: vm.$t('atencion'),
                                        text: response.data.message,
                                        confirmButtonClass: 'btn btn-info btn-fill',
                                        type: 'error'
                                    });
                                    vm.respuesta = false;

                                }
                                vm.loading = false;

                            })
                            .catch(function (error) {
                                console.log(error);
                            });
                    }
                }
            },
            searchCliente(query) {
                if (query !== '') {
                    const controller = 'searchClients/' + query;
                    var config = {
                        params: {
                            idCompany: this.idCompany,
                            active: this.mostrarClientesBaja ? 0 : 1,
                            jwt: this.$store.getters.jwt
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "clients/" + controller, config)
                        .then(function (response) {
                            if (response.data.response) {


                                vm.listClientes = response.data.result;
                            }
                            else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            },

            /*Tickets*/

            getTicketsClient(days) {

                if (this.idBusiness !== 0) {

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            jwt: this.$store.getters.jwt,
                            idCliente: this.idCliente,
                            idDay: days,
                            datefrom: moment(this.datefrom).startOf("day").unix(),
                            dateto: moment(this.dateto).endOf("day").unix(),
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "clients/getTicketsByIdClient", config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.listTickets = response.data.result.tickets;
                                vm.vistaTicket = true;

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
                else if (this.listBusinesses.length===2) {


                    var config = {
                        params: {
                            idBusiness: this.listBusinesses[1]["id"],
                            jwt: this.$store.getters.jwt,
                            idCliente: this.idCliente,
                            idDay: days,
                            datefrom: moment(this.datefrom).startOf("day").unix(),
                            dateto: moment(this.dateto).endOf("day").unix(),
                        },
                        headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                    };

                    let vm = this;
                    this.axios.get(this.$store.getters.apiUrl + "clients/getTicketsByIdClient", config)
                        .then(function (response) {
                            if (response.data.response) {
                                vm.listTickets = response.data.result.tickets;
                                vm.vistaTicket = true;
                                

                            } else {
                                swal({
                                    title: vm.$t('atencion'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });

                }
                else {

                    swal({
                        title: this.$t('atencion'),
                        text: this.$t('seleccioneUnNegocioParaVerLosTickets'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }

        }
    }
</script>

<style scoped>


    a li {
        color: #111;
    }

    .card {
        padding: 20px;
    }

    .div-export {
        margin-bottom: 10px;
    }

    .acciones-icons .btn-link {          
        padding: 0;       
    }

    button:disabled {
        background-color: #999999 !important;
        border-color: #777777 !important;
        color: #ffffff !important;
        cursor: not-allowed !important;
        opacity: 0.7;
    }

    button:disabled:hover {
        background-color: #999999 !important;
        border-color: transparent !important;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Clientes/ConsultarVentasCliente.vue